export default __webpack_public_path__ + "static/media/message.6af830fc.svg";